<template>
    <div class="StoreInfo BrandInfo">
        <navigation-bar Back Bell :name="brandInfo.name"/>
        <div class="main">
            <div class="container mb-4">
                <div class="shadow-box">
                    <banner v-if="brandInfo.brandImgAry.length > 0" :list="brandInfo.brandImgAry" :store="Number(1)"/>
                    <img v-else :src="brandInfo.imgUrl" class="banner-image">

                    <div class="card-body">
                        <div class="list-style border-0 pb-0 pt-0">
                            <div class="content">
                                <a class="phone-btn mb-2" @click="$public.callTel(brandInfo.phone)" v-if="brandInfo.phone !== ''">
                                    <img src="@/assets/images/phone.svg">
                                    <span>{{brandInfo.phone}}</span>
                                </a>
                                <a class="location-btn" v-if="brandInfo.address !== ''" @click="onClickLocationBtn(0, 0, brandInfo.googleMapUrl)">
                                    <img src="@/assets/images/location_blue.svg">
                                    <span>{{brandInfo.address}}</span>
                                </a>
                            </div>
                        </div>

                        <el-button class="join" v-show="isLogin" :class="{active:isMember}">
                            <p v-show="isMember">
                                <i class="el-icon-check"/>
                                <span>已為會員</span>
                            </p>
                            <p v-show="!isMember" @click="onClickAddMember()">
                                <img src="@/assets/images/join_store_white.svg">
                                <span>加入會員</span>
                            </p>
                        </el-button>

                    </div>

                </div>
                <div class="d-flex mt-2">
<!--                    <div class="business-hours" v-show="isShowBusinessHours(brandInfo)" @click="showBusiness=!showBusiness" >-->
                    <div class="business-hours" v-show="false" @click="showBusiness=!showBusiness" >
                        <span class="status">{{brandInfo.businessHours.businessStatusString}}．</span>{{brandInfo.businessHours.endBusinessTimePeriodString}}
                        <i class="el-icon-caret-bottom" v-show="!showBusiness"></i>
                        <i class="el-icon-caret-top" v-show="showBusiness"></i>
                    </div>

                    <!--todo FB、IG、YT等連結-->
                    <Links :socialWebsites="brandInfo.websites" :socialWebsitesStatus="brandInfo.websiteStatus" :iconType="iconType" isBrand  v-if="brandInfo.websiteStatus"/>
                </div>
                <el-row type="flex" v-show="showBusiness">
                    <ul class="text-left business-hours">
                        <li class="week">星期一 <span v-html="showBusinessTime(brandInfo.businessHours.monday)"></span></li>
                        <li class="week">星期二 <span v-html="showBusinessTime(brandInfo.businessHours.tuesday)"></span></li>
                        <li class="week">星期三 <span v-html="showBusinessTime(brandInfo.businessHours.wednesday)"></span></li>
                        <li class="week">星期四 <span v-html="showBusinessTime(brandInfo.businessHours.thursday)"></span></li>
                        <li class="week">星期五 <span v-html="showBusinessTime(brandInfo.businessHours.friday)"></span></li>
                        <li class="week">星期六 <span v-html="showBusinessTime(brandInfo.businessHours.saturday)"></span></li>
                        <li class="week">星期日 <span v-html="showBusinessTime(brandInfo.businessHours.sunday)"></span></li>
                    </ul>
                </el-row>

                <!--todo 外送資訊-->
                <div class="takeout-list single" v-show="isShowRemark(brandInfo)" @click="isOpen">
                    <div class="title" style="color: #fff">
                        <div v-if="!isNoteIconError">
                            <img :src="isNoteIconEmpty(brandInfo.noteIcon) ? require('@/assets/images/remark/remark_'+brandInfo.noteIcon+'.svg'):''" @error="onImgError"/>{{brandInfo.title}}：
                        </div>
                        <div v-else>
                            <img :src="require('@/assets/images/remark/remark_01.svg')"/>{{brandInfo.title}}：
                        </div>
                    </div>
                    <div class="con" style="color: #fff" v-html="getRemark(brandInfo)"/>
                    <div class="icon-arrow">
                        <i class="el-icon-caret-bottom"/>
                    </div>
                </div>

                <div class="wrap-menu">
                    <div class="item" v-if="brandInfo.isBranchStore" @click="onClickFuncBtn('usefulStore', {brandId: id})">
                        <img src="@/assets/images/store/store.svg">
                        <span>門市資訊</span>
                    </div>
                    <div class="item" v-show="showHidden" @click="showToast('此功能尚未開放')">
                        <img src="@/assets/images/store/opinion.svg">
                        <span>意見反映</span>
                    </div>
                    <div class="item" v-show="showHidden">
                        <img src="@/assets/images/store/comment.svg">
                        <span>評論</span>
                    </div>
                    <div class="item" v-show="showHidden">
                        <img src="@/assets/images/store/order.svg" alt="">
                        <span>點餐</span>
                    </div>
                </div>
                <div class="about mt-4" v-show="isShowAbout(brandInfo)">
                    <category-header title="關於我們" class="ml-0 mb-2"/>
                    <template v-show="brandInfo.description !== undefined && brandInfo.description !== ''">
                        <div class="text-content" v-if="aboutOpen" v-html="brandInfo.description"/>
                        <div class="text-content" v-else v-html="aboutText.substring(0, 45) + '...'"/>

                        <div :class="aboutOpen?'read-more-close':'read-more'"
                             @click="[aboutOpen=!aboutOpen, sendClickFuncGAEvent('click_關於我們')]">
                            <template v-if="aboutOpen">向上收合</template>
                            <template v-else>繼續閱讀</template>
                        </div>
                    </template>
                </div>
                <div class="about mt-4 mb-4" v-show="isShowVideo(videoUrl)">
                    <div class="video-container">
                        <iframe id="brand-video-frame" width="560" height="315" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
                    </div>
                </div>
            </div>
            <category-content v-show="brandInfo.photoImageAry !== undefined && brandInfo.photoImageAry.length > 0">
                <category-header title="PHOTOS"/>
                <item-grid v-show="$public.notNull(brandInfo.photoImageAry)">
                    <vue-preview :slides="photoArray"/>
                </item-grid>
            </category-content>
            <category-content v-show="brandInfo.recommendStatus">
<!--                <category-header :to="{name: 'CommodityList',query:{brandId:id}}" title="推薦商品" v-show="brandInfo.recommendList !== undefined && brandInfo.recommendList.length > 0"/>-->
                <category-header :to="{name: 'CommodityList',query:{id: id, type: 'brand'}}" title="推薦商品" v-show="brandInfo.recommendList !== undefined && brandInfo.recommendList.length > 0"/>
                <item-grid>
                    <div class="menu-block" v-for="(item, index) in brandInfo.recommendList" :key="'recommend'+index">
<!--                        <div @click="$router.push({name: 'MealInfo',params:{mealId:item.id}})" class="cover">-->
<!--                        <div class="cover">-->
                        <div @click="[sendClickFuncGAEvent('click_推薦商品'), onClickProposeItem(item.id)]" class="cover">
                            <img :style="{backgroundImage: 'url(' + item.image + ')' }" class="size-cover">
                        </div>
                    </div>
                </item-grid>
            </category-content>
        </div>
        <comm-dialog :value="dialog.isShowDialog"
                     :outerContent="dialog.dialogMsg"
                     :isCancel="dialog.cancelable"
                     @result="onCommDialogClose"/>
        <join-member-dialog :value="joinDialog.isShowDialog" :outerContent="joinDialog.dialogTitle" :mainContent="joinDialog.dialogMsg" :isCancel="joinDialog.cancelable" @result="onJoinMemberDialogClose"/>
        <toast/>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import Banner from '@/components/BannerSlider.vue';
    import {notNull} from '@/util/common';
    import JoinMemberDialog from "../../components/JoinMemberDialog";
    import CommDialog from "@/components/CommDialog";
    import CategoryContent from '@/components/category/Content.vue';
    import CategoryHeader from '@/components/category/Header.vue';
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import Links from "../../views/complex/components/Links";
    import Analytics from "@/util/analytics";

    export default {
        name: "BrandInfo",
        components: {
            Toast,
            Banner,
            JoinMemberDialog,
            CommDialog,
            CategoryContent,
            CategoryHeader,
            ItemGrid,
            Links,
        },
        data() {
            return {
                isLoading: false,
                isLogin: this.$auth.isAdminLogin(),
                isMember: false,
                id: Number(this.$route.query.id),
                brandInfo: {
                    id:0,

                    about: '',
                    address: '',
                    brandAddress: '',           //品牌地址
                    brandImgAry: [],
                    businessHours: {
                        monday: [],
                        tuesday: [],
                        wednesday: [],
                        thursday: [],
                        friday: [],
                        saturday: [],
                        sunday: [],
                        businessStatusString: '',
                        endBusinessTimePeriodString: '',
                    },
                    city: '',
                    coverImageUrl: '',
                    description: '',            //描述
                    descriptionStatus: false,   //是否顯示描述
                    facebook: '',
                    googleMapUrl: '',
                    imgUrl: '',
                    instagram: '',
                    isBranchStore: false,
                    isShowBusinessTime: false,
                    lat: 0,
                    lng: 0,
                    maxPrice: 0,
                    minPrice: 0,
                    name: '',
                    noteAry: [],
                    noteIcon: '',
                    noteStatus: false,
                    officialWebsite: '',
                    officialWebSiteStatus: false,
                    phone: '',
                    photoImageAry: [],
                    priceStatus: false,
                    recommendList: [],          //推薦商品區
                    recommendStatus: false,     //推薦商品開啓狀態

                    // showBusiness: false,
                    telMain: '',        //營業電話(主要)
                    telSubsidiary: '',   //營業電話(次要)
                    title: '',          //備註的標題
                    townShip: '',
                    youtube: '',

                    zipCode: '',

                    websites: '',
                    websiteStatus: false,
                },
                iconType: 'isBrand',

                photoArray: [],     //菜單放大圖用

                showBusiness: false,
                showHidden: false,

                scrollTop: '',      //回 StoreList 用
                scrollHeight:'',    //回 StoreList 用

                videoUrl: '',       //youtube影片用
                //dialog 用
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                //dialog 用
                joinDialog: {
                    isShowDialog: false,
                    dialogTitle: '',
                    dialogMsg: '',
                    cancelable: false,
                },
                //關於我們看更多
                aboutOpen: false,
                //關於我們轉純文字字串
                aboutText: '',

                //載圖錯誤旗標
                isNoteIconError: false,

            }
        },
        created() {

        },
        mounted() {
            if (this.id === undefined || this.id === 0) {
                this.$public.showNotify("id錯誤", false);
            } else {

                this.setupData();
                if (this.isLogin) {
                    this.isJoinMember(this.id);
                }

            }
        },
        methods: {

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
            },

            /** 加入會員訊息 dialog */
            showJoinMemberDialog: function (title, msg, cancelable = false) {
                this.joinDialog.cancelable = cancelable;
                this.joinDialog.dialogTitle = title;
                this.joinDialog.dialogMsg = msg;
                this.joinDialog.isShowDialog = true;
            },

            /** JoinMemberDialog 關閉事件 */
            onJoinMemberDialogClose: function(result) {
                this.joinDialog.isShowDialog = false;

                if(result) {
                    if (this.id > 0) {
                        let self = this;
                        self.isLoading = true;
                        //加入會員
                        self.addMember(self.id)
                            .then( () => {
                                self.isLoading = false;
                                //加入成功
                                self.showDialog(`加入會員成功`);

                                //發出GA事件記錄
                                self.sendClickFuncGAEvent("join_member");
                            })
                            .catch( (error) => {
                                self.isLoading = false;
                                self.$store.commit(mutationTypes.SHOW_TOAST, error);
                            });
                    }
                }
            },

            /**  */
            setupData: function () {
                let self = this;
                self.isLoading = true;

                this.$http.fetch`GetBrandInfo${{
                  brandId: self.id,
                }} ${json => {

                    if (json.data !== null && json.data !== '') {
                      //console.log(json.data)
                        self.brandInfo = json.data;
                        self.isNoteIconError = false;   //要改變這個數值，才能再讓備註icon重新載入，看看 icon有沒有載入錯誤

                        self.changeVideoUrl(self.brandInfo.youtube);

                        //發出GA事件記錄
                        self.sendClickFuncGAEvent("open_brand_info");

                        //菜單和放大圖使用
                        json.data.photoImageAry.forEach(function (item, index) {
                            const newImg = new Image()
                            newImg.onload = () => {
                                self.photoArray.push(
                                    {
                                        src: item,//大圖
                                        msrc: item,//小圖
                                        w: newImg.width,//抓圖片原始的寬
                                        h: newImg.height//抓圖片原始的高
                                    }
                                );
                            }
                            newImg.src = item
                        });
                    }

                    self.isLoading = false;
                  }
                }}`;
            },

            /** 點擊 加入會員 */
            onClickAddMember : function() {
                if (this.isMember) {
                    this.$store.commit(mutationTypes.SHOW_TOAST, '已經加入該品牌會員');
                } else {

                    this.showJoinMemberDialog("加入會員", "是否同意成爲品牌會員？", true);
                }
            },

            /** 點擊推薦商品圖片 */
            onClickProposeItem: function (mealId) {
                //開啓地圖
                this.$router.push({name: 'MealInfo',query:{mealId: mealId, type : 'brand'}})
            },

            /** 點擊功能按鈕 */
            onClickFuncBtn: function (func, param) {

                //不需要登入的功能
                if (func === 'usefulStore') {
                    //門市資訊
                    //發出GA事件記錄
                    this.sendClickFuncGAEvent("click_門市資訊");
                    this.$router.push({name: 'UsefulStoreList', query:{type: 'brand', id: param.brandId}});
                    return;
                }


                //需要登入才能用的功能
                if (!this.isLogin) {
                    this.showToast('請先登入後再使用本功能');

                } else {
                    if (this.isMember !== undefined && !this.isMember) {
                        this.showJoinMemberDialog("您尚未成爲此品牌會員", "加入會員能使用此功能，是否成爲此品牌的會員？", true);
                    } else {
                        switch(func) {
                            case 'comment': //評論
                                this.showToast('本功能尚未開放');
                                break;
                            case 'reflect': //意見反映
                                this.showToast('本功能尚未開放');
                                break;
                            case 'order':   //點餐
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_點餐");
                                // this.$router.push({name: 'OrderList', query:{id: this.storeInfo.id}});
                                break;
                            case 'waiting': //候位
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_候位");
                                // this.$router.push({name: 'OrderList', query:{id: this.storeInfo.id}});
                                // this.showToast('本功能尚未開放');
                                break;
                            case 'booking': //訂位
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_訂位");
                                break;
                            case 'bookingRecord': //訂位記錄
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_訂位記錄");
                                break;
                            case 'bulletin': //公告
                                //發出GA事件記錄
                                this.sendClickFuncGAEvent("click_公告");
                                break;
                            default:
                                this.showToast('本功能尚未開放');
                                break;
                        }
                    }
                }
            },

            /** 發出點擊功能鈕的 GA事件 */
            sendClickFuncGAEvent: function (eventName) {
                if (this.$public.notNull(this.brandInfo)) {
                    let brandName = this.$public.notNull(this.brandInfo.name)? this.brandInfo.name:'';
                    let eventTitle = this.$public.getClearStrRegExp(`${eventName}_brand_${brandName}`.replace(/ /g, ""));
                    this.$public.addGAEventLog(eventTitle, {brand_name: brandName.replace(/ /g, "")});
                } else {
                    this.$public.addGAEventLog(`${eventName.replace(/ /g, "")}_brand`, {brand_name: ""});
                }
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                if (this.$public.notNull(url) && url !== "") {
                    this.videoUrl = this.$public.getEmbedVideoUrl(url);
                    let frame = document.getElementById('brand-video-frame');
                    if (this.$public.notNull(frame)) {
                        frame.src = this.videoUrl;
                    }
                }
            },

            /** 是否顯示影片 url */
            isShowVideo: function (videoUrl) {
                return (this.$public.notNull(videoUrl) && videoUrl !== "")
            },

            /** icon是否爲空？ */
            isNoteIconEmpty: function(noteIcon) {
                return (this.$public.notNull(noteIcon) && noteIcon !== '');
            },

            /** 是否加入會員 */
            isJoinMember: function (brandId) {
              let self = this;
              //取得店家資訊
              self.isLoading = true;
              self.$http.fetchWithAuth`IsAddBrand${{
                id: brandId,
              }} ${json => {
                self.isMember = json.status;
              }}`;
            },

            /** 加入成爲會員 */
            addMember: function(brandId) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`AddBrand${{
                        id: brandId
                    }} ${json => {
                        self.isMember = json.status;

                        if (json.status) {
                            const analytics = Analytics.getInstance(self.$route, self.$route.name);
                            analytics.sendEvent(Analytics.EVENTS.JOIN_MEMBER, {
                                brandId: brandId,
                                page: self.$route.name,
                            });

                            //完成
                            resolve();
                        } else {
                            reject('無法加入會員:' + json.message);
                        }

                    }}`;
                });
            },

            showBusinessTime: function (item) {
              if (item !== "休息日") {
                let showTime = "";
                item.forEach(function (value) {
                  showTime = showTime + value + '<br/>';
                })
                return showTime.slice(0, showTime.length-5);
              } else {
                return "休息日"
              }
            },

            showToast:function(message) {
                this.$store.commit(mutationTypes.SHOW_TOAST, message);
            },

            /** 點擊地點按鈕 */
            onClickLocationBtn: function (lat = 0, lng = 0, googleMapUrl = null) {
                // console.log(`onClickLocationBtn lat: ${lat}, lng: ${lng}, googleMapUrl: ${googleMapUrl}`);
                if (this.$public.notNull(googleMapUrl) && googleMapUrl !== '') {
                    let param = this.$public.analyzeGoogleMapUrl(googleMapUrl);
                    // console.log(`param lat: ${param.googleMapLat}, lng: ${param.googleMapLng}, googleMapUrl: ${param.googleMapStoreInfoData}`);
                    if (this.$public.notNull(param)) {
                        //開啓地圖
                        if (this.$public.notNull(param.googleMapStoreInfoData) && param.googleMapLat > 0 && param.googleMapLng > 0) {
                            //爲避免店家輸入的url打開後效果不統一，一律先分析再從公用函式開啓頁面
                            this.$public.openMap(param.googleMapLat, param.googleMapLng, param.googleMapStoreInfoData);
                        } else {
                            this.$public.openMap(param.googleMapLat, param.googleMapLng);
                        }
                    }

                } else if (lat !== 0 && lng !== 0) {
                    this.$public.openMap(lat, lng);
                }
            },

            /** 外送詳細開合 */
            isOpen: function() {
                document.getElementsByClassName('takeout-list')[0].classList.toggle("open")
            },

            /** 是否顯示備註 */
            isShowRemark: function(brandInfo) {
                let result = false;
                if (this.$public.notNull(brandInfo) && this.$public.notNull(brandInfo.noteStatus)) {
                    result = brandInfo.noteStatus &&
                        (this.$public.notNull(brandInfo.title) && brandInfo.title !== '') &&
                        (this.$public.notNull(brandInfo.noteAry)) &&
                        brandInfo.noteAry.length > 0;
                }
                return result ;
            },

            /** 備註 */
            getRemark: function(brandInfo) {
                let result = '';
                if (brandInfo.noteAry !== undefined &&
                    brandInfo.noteAry !== null &&
                    brandInfo.noteAry.length > 0) {
                    brandInfo.noteAry.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /** 是否顯示營業時間 */
            isShowBusinessHours: function(brandInfo) {
                let result = false;
                if (this.$public.notNull(brandInfo) && this.$public.notNull(brandInfo.isShowBusinessTime)) {
                    result = brandInfo.isShowBusinessTime && this.$public.notNull(brandInfo.businessHours) ;
                }
                return result ;
            },

            /** 是否顯示關於我們 */
            isShowAbout: function(brandInfo) {
                let result = false;
                if (this.$public.notNull(brandInfo) && this.$public.notNull(brandInfo.description)) {
                    result = brandInfo.descriptionStatus && (brandInfo.description !== '');
                    let msg = brandInfo.description.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
                    msg = msg.replace(/&nbsp;/ig, ''); //去掉&nbsp
                    this.aboutText = msg
                }
                return result ;
            },

            /** 載圖錯誤 */
            onImgError: function() {
                this.isNoteIconError = true;
            },

        }
    }
</script>

<style lang="less" scoped src="../../less/store.less"/>
